import React from 'react';
import * as S from './PremiunFeatures.styles';
import Icon from "../../../../core-components/IconsSelector";

interface IFeature {
    title: string;
    icon: string;
  }

interface IFeatures {
    feature: Array<IFeature>;
    title: string;
    color: Array<string>;
    is_ryde: boolean;
}

export default function ({ title = "", color = [], feature = [], is_ryde = false }: IFeatures) {
    if(is_ryde){
        title = "Ryde assured promises";
        color[0] = "#fff";
        color[1] = "#fff";
    }
    return (
        <React.Fragment>
            <S.PremiumTitleWrapper>
                <S.IconWrap>
                    <Icon name="Iconback" />
                </S.IconWrap>
                <S.PremiumTagWrap primaryColor={color?.[0]} secondaryColor={color?.[1]}>{title}</S.PremiumTagWrap>
            </S.PremiumTitleWrapper>
            <S.PremiumFeatureWrapper>
                {feature?.map(({ title = "", icon = "" }) => (
                    <S.PremiumFeature>
                        <S.IconWrap borderWidth="0">
                            <S.FeatureImage alt="amentity" src={icon} />
                        </S.IconWrap>
                        <S.PremiumFeatureText>{title}</S.PremiumFeatureText>
                    </S.PremiumFeature>
                ))}
            </S.PremiumFeatureWrapper>
        </React.Fragment>
    );
}